// @flow

export const CREATE = 'CREATE'
export const EDIT = 'EDIT'
export const CLONE = 'CLONE'
